import {ChapterOpener} from '@sdox/ui'

import {xcMediaRefToMediaItem} from '../../'

import type {ResponsiveMediaType} from '@sdox/ui'
import type {XcNwBlock_BlockChapterOpenerType_Fragment} from '@sdox/api'

export const BlockChapterOpener = (props: XcNwBlock_BlockChapterOpenerType_Fragment) => {
  const {title, chapterOpenerMedia, chapterOpenerMediaMobile, count} = props
  const media: ResponsiveMediaType = {
    desktop: chapterOpenerMedia ? xcMediaRefToMediaItem(chapterOpenerMedia) : undefined,
    mobile: chapterOpenerMediaMobile ? xcMediaRefToMediaItem(chapterOpenerMediaMobile) : undefined,
  }

  return (
    <ChapterOpener
      title={title}
      count={count ?? undefined}
      media={media}
    />
  )
}
